export const PUBLIC_SUPPLIER_QUERY = '/public/suppliers';
export const INVITE_QUERY = '/invites';
export const SESSION_QUERY = '/auth/session';
export const AVAILABLE_ORGS_QUERY = '/auth/available-orgs';
